import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./baseQuery";
import { API } from "./constant";

export const payrollApi = createApi({
  baseQuery,
  reducerPath: "payrollApi",
  tagTypes: ["payroll", "budget", "coopMgt"],
  endpoints: (builder) => ({
    payrollStaffData: builder.query({
      query: ({ ...values }) => ({
        url: API.PAYROLL_OF_ALL_EMPLOYEES,
        params: { ...values },
        method: "GET",
      }),
      providesTags: (responseObject) =>
        responseObject
          ? [
              ...(responseObject?.employeePayrollBatchDetails?.map(
                ({ id }) => ({
                  type: "payroll",
                  id,
                })
              ) ?? []),
              "payroll",
            ]
          : ["payroll"],
    }),
    removeFromPayroll: builder.mutation({
      query: ({ ...values }) => ({
        url: API.REMOVE_FROM_PAYROLL,
        method: "POST",
        body: { ...values },
      }),
    }),
    approvePayroll: builder.mutation({
      query: ({ ...values }) => ({
        url: API.APPROVE_PAYROLL,
        method: "POST",
        body: { ...values },
      }),
      invalidatesTags: ["payroll"],
    }),
    declinePayroll: builder.mutation({
      query: ({ ...values }) => ({
        url: API.DECLINE_PAAYROLL,
        method: "POST",
        body: { ...values },
      }),
      invalidatesTags: ["payroll"],
    }),
    authorizePayroll: builder.mutation({
      query: ({ ...values }) => ({
        url: API.AUTHORIZE_PAYROLL,
        method: "POST",
        body: { ...values },
      }),
      invalidatesTags: ["payroll"],
    }),
    getAllViewItems: builder.query({
      query: () => ({
        url: API.PAYROLL_VIEW_ALL_ITEMS,
        method: "GET",
      }),
    }),
    getvVewBonus: builder.query({
      query: () => ({
        url: API.PREVIEW_BONUS,
        method: "GET",
      }),
    }),
    getViewAllBonuses: builder.query({
      query: (SelectedComponent) => ({
        url: API.PREVIEW_ALL_BONUSES,
        method: "GET",
        params: SelectedComponent,
      }),
    }),
    getPaymentSummary: builder.query({
      query: (params) => ({
        url: API.PAYMENT_SUMMARY,
        method: "GET",
        params: params,
      }),
    }),
    getPaymentLog: builder.query({
      query: (params) => ({
        url: API.PAYMENT_LOG,
        method: "GET",
        params: params,
      }),
    }),
    getVendorPayments: builder.query({
      query: (params) => ({
        url: API.vendorPaymentDetails,
        method: "GET",
        params: params,
      }),
    }),
    getAllPaymentRequst: builder.query({
      query: ({ CreatedDate, PaymentTypeId, BatchId }) => ({
        url: API.PAYMENT_DETAILS,
        // url: API.PAYMENT_SUMMARY,
        method: "GET",
        params: { CreatedDate, PaymentTypeId, BatchId },
      }),
    }),
    addBudget: builder.mutation({
      query: (formData) => {
        return {
          url: API.ADD_BUDGET,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: ["budget"],
    }),
    getBudgetSummary: builder.query({
      query: ({ ...values }) => ({
        url: API.GET_BUDGET_SUMMARY,
        method: "GET",
        params: { ...values },
      }),
    }),
    getBudgetDetails: builder.query({
      query: ({ ...values }) => ({
        url: API.GET_BUDGET_DETAILS,
        method: "GET",
        params: { ...values },
      }),
    }),
    approveAndDeclineBudgetDetails: builder.mutation({
      query: ({ ...values }) => ({
        url: API.APPROVE_AND_DECLINE_BUDGET_DETAILS,
        method: "POST",
        body: { ...values },
      }),
      invalidatesTags: ["budget"],
    }),
    getBudgetDetailsById: builder.query({
      query: ({ ...values }) => ({
        url: API.GET_BUDGET_DETAILS_BY_ID + `/${values.id}`,
        method: "GET",
        params: { ...values },
      }),
    }),
    approveBudget: builder.mutation({
      query: ({ ...values }) => ({
        url: API.APPROVE_BUDGET,
        method: "POST",
        body: { ...values },
      }),
    }),
    getLedger: builder.query({
      query: ({ ...values }) => ({
        url: API.GET_LEDGER,
        method: "GET",
        params: { ...values },
      }),
    }),
    getDepartment: builder.query({
      query: ({ ...values }) => ({
        url: API.GET_DEPARTMENT,
        params: { ...values },
        method: "GET",
      }),
    }),
    linkBudgetToPayment: builder.mutation({
      query: ({ ...values }) => ({
        url: API.LINK_BUDGET_TO_PAYMENT,
        method: "POST",
        params: { ...values },
      }),
    }),
    getLedgerAccounts: builder.query({
      query: ({ ...values }) => ({
        url: API.LEDGER_ACCOUNTS,
        params: { ...values },
        method: "GET",
      }),
    }),
    linkToLedger: builder.mutation({
      query: ({ ...values }) => ({
        url: API.LINK_LEDGER_TO_PAYMENT,
        method: "POST",
        params: { ...values },
      }),
    }),
    getPaymentType: builder.query({
      query: ({ ...values }) => ({
        url: API.PAYMENT_TYPE,
        method: "GET",
        params: { ...values },
      }),
    }),
    getAllAccounts: builder.query({
      query: ({ ...values }) => ({
        url: API.GET_ACCOUNTS,
        method: "GET",
        params: { ...values },
      }),
    }),
    getCompanyFunds: builder.query({
      query: ({ ...values }) => ({
        url: API.GET_COMPANY_FUNDS,
        method: "GET",
        params: { ...values },
      }),
    }),
    approvePaymentRequest: builder.mutation({
      query: ({ ...values }) => ({
        url: API.APPROVE_PAYMENT_REQ,
        method: "POST",
        body: { ...values },
      }),
    }),
    declinePaymentRequest: builder.mutation({
      query: ({ ...values }) => ({
        url: API.Decline_PAYMENT_REQ,
        method: "POST",
        body: { ...values },
      }),
    }),
    getCooperativeMgt: builder.query({
      query: ({ ...values }) => ({
        url: API.ALL_COOPERATIIVE_MGT,
        method: "GET",
        params: { ...values },
      }),
      providesTags: (result, error, arg) =>
        result
          ? [
              ...(result?.data?.map(({ id }) => ({
                type: "coopMgt",
                id,
              })) ?? []),
              "coopMgt",
            ]
          : ["coopMgt"],
    }),
    getNonStatutoryAdviceMgt: builder.query({
      query: ({ ...values }) => ({
        url: API.ALL_NON_STATUTORY_MGT,
        method: "GET",
        params: { ...values },
      }),
      providesTags: (result, error, arg) =>
        result
          ? [
              ...(result?.data?.map(({ id }) => ({
                type: "nsaMgt",
                id,
              })) ?? []),
              "nsaMgt",
            ]
          : ["nsaMgt"],
    }),
    uploadNSADeductions: builder.mutation({
      query: (formData) => {
        return {
          url: API.UPLOAD_NON_STATUTORY_DEDUCTIONS,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: ["nsaMgt"],
    }),
    uploadDeductions: builder.mutation({
      query: (formData) => {
        return {
          url: API.UPLOAD_COOPERATIVE_DEDUCTIONS,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: ["coopMgt"],
    }),
    generatePaymentSchedule: builder.mutation({
      query: ({ ...values }) => ({
        url: API.DOWNLOAD_PAYMENT_SCHEDULE,
        body: { ...values },
        method: "POST",
      }),
    }),
    approveDeclineCooperative: builder.mutation({
      query: ({ ...values }) => ({
        url: API.APPROVE_DECLINE_COOPERATIVE,
        method: "POST",
        body: { ...values },
      }),
      invalidatesTags: ["coopMgt"],
    }),
    approveDeclineNonStatutoryAdvice: builder.mutation({
      query: ({ ...values }) => ({
        url: API.APPROVE_DECLINE_NON_STATUTORY_ADVICE,
        method: "POST",
        body: { ...values },
      }),
      invalidatesTags: ["nsaMgt"],
    }),
    authorizeNonStatutoryAdvice: builder.mutation({
      query: ({ ...values }) => ({
        url: API.AUTHORIZE_NON_STATUTORY_ADVICE,
        method: "POST",
        body: { ...values },
      }),
      invalidatesTags: ["nsaMgt"],
    }),
    authorizeCooperative: builder.mutation({
      query: ({ ...values }) => ({
        url: API.AUTHORIZE_COOPERATIVE,
        method: "POST",
        body: { ...values },
      }),
      invalidatesTags: ["coopMgt"],
    }),
    removeDeductions: builder.mutation({
      query: ({ ...values }) => ({
        url: API.REMOVE_DEDUCTIONS,
        method: "POST",
        body: { ...values },
      }),
    }),
  }),
});

export const {
  useApprovePayrollMutation,
  useDeclinePayrollMutation,
  useDeclinePaymentRequestMutation,
  usePayrollStaffDataQuery,
  useGetAllViewItemsQuery,
  useGetvVewBonusQuery,
  useGetViewAllBonusesQuery,
  useGetAllPaymentRequstQuery,
  useGetPaymentSummaryQuery,
  useAuthorizePayrollMutation,
  useAddBudgetMutation,
  useGetBudgetSummaryQuery,
  useGetBudgetDetailsQuery,
  useApproveBudgetMutation,
  useGetLedgerQuery,
  useLinkBudgetToPaymentMutation,
  useGetLedgerAccountsQuery,
  useLinkToLedgerMutation,
  useGetPaymentTypeQuery,
  useGetAllAccountsQuery,
  useGetCompanyFundsQuery,
  useApprovePaymentRequestMutation,
  useUploadDeductionsMutation,
  useUploadNSADeductionsMutation,
  useGeneratePaymentScheduleMutation,
  useApproveDeclineCooperativeMutation,
  useAuthorizeCooperativeMutation,
  useGetCooperativeMgtQuery,
  useRemoveFromPayrollMutation,
  useRemoveDeductionsMutation,
  useApproveAndDeclineBudgetDetailsMutation,
  useGetBudgetDetailsByIdQuery,
  useGetVendorPaymentsQuery,
  useGetPaymentLogQuery,
  useGetDepartmentQuery,
  useGetNonStatutoryAdviceMgtQuery,
  useApproveDeclineNonStatutoryAdviceMutation,
  useAuthorizeNonStatutoryAdviceMutation
} = payrollApi;
